// src/modules/components/reports/teerab/TopPerformersList.js
import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  alpha,
  useTheme,
  Alert,
} from "@mui/material";
import { RecordContextProvider } from "react-admin";
import UserDialog from "../../../components/user-details"; // adjust path as needed

export const TopPerformersList = ({ title, data, icon: Icon }) => {
  const theme = useTheme();

  if (!data || data.length === 0) {
    return (
      <Alert severity="info">No {title.toLowerCase()} data available</Alert>
    );
  }

  return (
    <Card
      sx={{
        background: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(8px)",
        height: "100%",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          fontWeight="bold"
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Icon
            sx={{
              mr: 1,
              background: alpha(theme.palette.primary.main, 0.1),
              padding: "6px",
              borderRadius: "50%",
              color: theme.palette.primary.main,
            }}
          />
          {title}
        </Typography>

        <List sx={{ py: 0 }}>
          {data.map((item, index) => (
            <React.Fragment key={item.id}>
              <RecordContextProvider value={item.user}>
                <ListItem
                  sx={{
                    px: 0,
                    py: 1,
                    "&:hover": {
                      backgroundColor: alpha(theme.palette.primary.main, 0.05),
                      borderRadius: "8px",
                    },
                  }}
                >
                  <UserDialog source="user" />
                </ListItem>
              </RecordContextProvider>
              <ListItem
                sx={{
                  px: 0,
                  py: 1,
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    borderRadius: "8px",
                  },
                }}
              >
                <ListItemText
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      {item.orderCount} orders
                    </Typography>
                  }
                  sx={{ my: 0 }}
                />
                <Box
                  sx={{
                    background: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "12px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                  }}
                >
                  #{index + 1}
                </Box>
              </ListItem>
              {index < data.length - 1 && <Divider sx={{ my: 1 }} />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};